export const m = {
    voiceSearch: 'Voice',
    picSearch: 'Portrait',
    faceSearch: 'Face recognition',
    hotWord: 'Trending：',
    more: 'See More>',
    size: 'Size：',
    share: 'Share',
    fieldInfo: 'Log Info',
    autoCata: 'Auto Catalog',
    videoSize: 'File Size',
    duration: 'Duration',
    codeRate: 'Bit Rate',
    size: 'Size',
    format: 'Format',
    localUpload: 'Local Upload',
    similarCharacters: 'Similar Characters：',
    reIdentification: 'Re-identification',
    sendQuickCode: 'Send Quick Edits',
    videoDownload: 'Download',
    interceptingClips: 'Intercept segment',
    startTime: 'Start',
    endTime: 'End',
    confirmInterception: 'Confirm to Intercept',
    interceptionTime: 'Interception time',
    interceptNaming: 'Naming',
    submit: 'Submit',
    cancel: 'Cancel',
    myVideo: 'My Videos',
    transcoding: 'Transcoding...',
    downLoad: 'Click to download',
    save: 'Save',
    relatedVideo: 'Related videos',
    all: 'All',
    material: 'Data',
    match: 'Highlights/Multi Clips',
    person: 'Auto Character Collection',
    project: 'File download',
    date: 'Date',
    classify: 'Sort',
    loadMore: 'Load More',
    hideMore: 'Hide More',
    shoot: 'Take a photo',
    download2point5M: 'Proxy Video Download',
    download25M: 'Source Video Download',
    noCatalogue: 'This Video has no catalog',
    nologkeeper: 'This Video has no catalog',
    noReleateVideo: 'No related videos',
    noMyVideo: 'No my videos'
}
